/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ExternalRelatedItemListContent_data = {
    readonly items: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly slug: string;
                readonly " $fragmentRefs": FragmentRefs<"ExternalShowPageListItem_listItem">;
            } | null;
        } | null> | null;
    };
    readonly downloadToken: string;
    readonly " $refType": "ExternalRelatedItemListContent_data";
};
export type ExternalRelatedItemListContent_data$data = ExternalRelatedItemListContent_data;
export type ExternalRelatedItemListContent_data$key = {
    readonly " $data"?: ExternalRelatedItemListContent_data$data;
    readonly " $fragmentRefs": FragmentRefs<"ExternalRelatedItemListContent_data">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExternalRelatedItemListContent_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ExternalListItemConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ExternalListItemEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ExternalListItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ExternalShowPageListItem_listItem"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downloadToken",
      "storageKey": null
    }
  ],
  "type": "ExternalItemList",
  "abstractKey": null
};
(node as any).hash = 'b4e8948879646bc94605f36cd463fd71';
export default node;
